import React, { Component } from 'react'
import { StyleModal } from './style'
import { Button } from '../../../components'
import { MODAL_REASON } from '../../../helpers'
export class ModalReason extends Component {

  constructor(){
    super()
    this.state = {
      keyword: ''
    }
  }

  onChange = (event) => {
    this.setState({
      keyword: event.target.value
    })
  }
  render() {
    const {
      keyword
    } = this.state
    const {
      name,
      onClickCancel,
      validate,
      onClickAction,
      language
    } = this.props
    return (
      <StyleModal>
        <div className='div-Modal' />
        <div className='content-Modal'>
          <div className='sub-content'>
            <div className='head-modal'>
             {MODAL_REASON.HEAD[language]}
            </div>
            <div className='description'>
             {MODAL_REASON.DESCRIPTION[language](name)}
              <div>
                {MODAL_REASON.SURE[language]}
              </div>
            </div>
            <input 
              value={keyword}
              onChange={this.onChange}
              placeholder={MODAL_REASON.PLACEHOLDER[language]}
              className='input-delete'
            />
            {validate &&
              <div className='text-error'>
                {validate.description}
              </div>
            }
            <div className='tabel btn-modal'>
              <div className='table-row'>
                <div className='table-cell tabel-right'>
                  <Button
                    name={MODAL_REASON.KEEP[language]}
                    onClick={onClickCancel}
                    className='modal-btn-keep'
                  />
                </div>

                <div className='table-cell tabel-left'>
                  <Button
                    name={MODAL_REASON.DELETE[language]}
                    disabled={ keyword === ''}
                    onClick={()=>{
                      onClickAction(keyword)
                    }}
                    className={`modal-btn-delete ${keyword !== ''? 'is-pass':''}`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </StyleModal>
    )
  }
}
